/* eslint-disable no-console -- Intentional console logging utility */
import {environment} from "../../../environments/environment";

export class Message {
  private readonly notExistingFeature: string;

  constructor() {
    this.notExistingFeature = 'feature not available';
  }

  /**
   * Logs messages to the console if logging is enabled in the environment settings.
   *
   * @param messages - The messages to log.
   */
  log(...messages: unknown[]): void {
    if (environment.messages.console) {
      console.log(...messages);
    }
  }

  /**
   * Logs error messages to the console if logging is enabled in the environment settings.
   *
   * @param messages - The error messages to log.
   */
  error(...messages: unknown[]): void {
    if (environment.messages.console) {
      console.error('Error:', ...messages);
    }
  }

  /**
   * Displays an alert message if alerts are enabled in the environment settings.
   *
   * @param message - The alert message to display.
   */
  alert(message: string): void {
    if (environment.messages.alert) {
      window.alert(message);
    }
  }

  /**
   * Displays a confirmation dialog if confirmations are enabled in the environment settings.
   *
   * @param message - The confirmation message to display.
   * @returns A boolean indicating if the user confirmed.
   */
  confirm(message: string): boolean {
    if (environment.messages.confirm) {
      return window.confirm(message);
    }
    return false;
  }

  /**
   * Logs a notification message to the console if notifications are enabled in the environment settings.
   *
   * @param messages - The notification message or messages to log.
   */
  notify(messages: string | string[]): void {
    if (environment.messages.notify) {
      console.log('Notify:', this.notExistingFeature, ...Array.isArray(messages) ? messages : [messages]);
    }
  }

  /**
   * Logs tracking messages to the console if logging is enabled in the environment settings.
   *
   * @param messages - The tracking messages to log.
   */
  track(...messages: string[]): void {
    if (environment.messages.console) {
      console.error('Track:', ...messages);
    }
  }

  /**
   * Logs debug messages to the console if debugging is enabled in the environment settings.
   *
   * @param messages - The debug messages to log.
   */
  debug(...messages: unknown[]): void {
    if (environment.messages.debug) {
      console.error('Debug:', ...messages);
    }
  }
}
